<template>
  <base-content :data="data"
    :index="index"
    bodyClass="card-body-graph"
  >
      <template #card-header>
        <partial-title
          :title="name"
          :link="link"
          :lineClamp="2"
        />
      </template>

      <template #card-body>
        <ul class="pt-2">
          <partial-owners v-if="!isEmpty(data.owners)"
            :lineClamp="1"
            :owners="owners"
            :totalOwners="data.researchers_count"
            :highlights="highlightResearchers"
            :highlightKeys="['researchers.full_name.normalized', 'researchers.initial_name.normalized']"
            :renderWithLinkTo="false">
          </partial-owners>
          <li v-else class="min-height--25px d-block"></li>

          <partial-organisation v-if="!isEmpty(data.organisations)"
            :organisations="data.organisations"
            :highlights="highlightOrganisations"
            :highlightKey="'organisations.name'"
            :lineClamp="1">
          </partial-organisation>
          <li v-else class="min-height--25px d-block"></li>

          <matches v-if="!isEmpty(matches)" :matches="matches" class="mt-3" />

          <comparison-chart
            v-if="comparison === 'graph'"
            :isLoaded="isLocalGraphDataLoaded"
            :graphData="localGraphData"
            :hasError="hasErrorGraphData"
          />
          <expertises
            v-else
            :isLoaded="isExpertiseLoaded"
            :expertises="localExpertiseData"
            @clickExpertise="clickExpertise"
          />
        </ul>
      </template>

      <template #card-actions>
        <slot name="actions"></slot>
      </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/researchGroup'
import searchResultVisuals from '@/mixins/search/results/visuals'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialTitle from '@/components/search/results/partials/Title'
import PartialOrganisation from '@/components/search/results/partials/OrganisationsForBody'
import PartialOwners from '@/components/search/results/partials/OwnersForBody'
import ComparisonChart from '@/components/shared/chart/ComparisonChart'
import Expertises from '@/components/search/results/partials/Expertises'

export default {
  name: 'researchGroupResultBlock',
  mixins: [processing, searchResultVisuals],
  components: {
    Matches,
    PartialTitle,
    PartialOwners,
    PartialOrganisation,
    BaseContent,
    ComparisonChart,
    Expertises
  },
  methods: {
    clickExpertise (filter, bucket) {
      this.$router.push({
        name: 'research_group.explore',
        params: { id: this.data.slug, category: 'publications', buckets: `${filter}:${this.$options.filters.slugify(bucket)}` }
      })
    }
  }
}
</script>
